import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { Typography } from '@mui/material';
import { useFormik } from 'formik';
import { useNavigate, useSearchParams } from 'react-router-dom';

import { useAppDispatch } from '../../store/hooks';

import { ThunkPasswordRecovery, ThunkRecoveryCodeVerification } from '../../store/auth/thunks';
import { LOGIN } from '../../router/routes';

import Loader from '../../components/Loader';
import Input from '../../components/Input/Input';
import Button from '../../components/Button/Button';

import useStyles from './styles';
import { recoverPasswordValidationSchema } from './form';

const RecoverPassword: React.FC = () => {
  const [loading, setLoading] = useState<boolean>(true);
  const [userName, setUserName] = useState<string>('');
  const [processing, setProcessing] = useState<boolean>(false);

  const [params] = useSearchParams();

  const code = useMemo(() => params.get('code') ?? '', []);
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const classes = useStyles();

  const formik = useFormik({
    initialValues: {
      password: '',
      confirmPassword: '',
    },
    onSubmit: values => {
      setProcessing(true);
      dispatch(ThunkPasswordRecovery({ payload: { code, password: values.password } }))
        .unwrap()
        .then(() => {
          navigate(LOGIN);
        })
        .finally(() => {
          setProcessing(false);
        });
    },
    validationSchema: recoverPasswordValidationSchema,
  });

  const onMount = useCallback(() => {
    setLoading(true);
    dispatch(ThunkRecoveryCodeVerification({ code }))
      .unwrap()
      .then(res => {
        setUserName(res.userName);
      })
      .catch(() => {
        navigate(LOGIN);
      })
      .finally(() => {
        setLoading(false);
      });
  }, []);

  useEffect(() => {
    onMount();
  }, []);

  if (loading) return <Loader />;
  return (
    <div className={classes.container}>
      <form onSubmit={formik.handleSubmit} className={classes.form}>
        <Typography>
          <b>Hi, {userName}</b>
        </Typography>
        <Input
          name="password"
          formik={formik}
          label="Password"
          type="password"
          disabled={processing}
          required
        />
        <Input
          name="confirmPassword"
          formik={formik}
          label="Confirm Password"
          type="password"
          disabled={processing}
          required
        />

        <Button text="Submit" type="submit" disabled={processing} loading={processing} />
      </form>
    </div>
  );
};

export default RecoverPassword;
